import * as React from 'react';
import { Stack, getTheme } from 'office-ui-fabric-react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const theme = getTheme();
export const SectionHeader = _ref => {
  let {
    accentColor = theme.palette.themePrimary,
    children,
    commandBar
  } = _ref;
  const styles = {
    root: {
      borderWidth: '2px',
      borderStyle: 'none none solid none',
      borderColor: accentColor
    }
  };
  return /*#__PURE__*/_jsxs(Stack, {
    styles: styles,
    horizontal: true,
    tokens: {
      childrenGap: 2,
      padding: '0 0 10px 0'
    },
    children: [/*#__PURE__*/_jsx(Stack.Item, {
      grow: true,
      children: children
    }), /*#__PURE__*/_jsx(Stack.Item, {
      grow: true,
      children: commandBar && commandBar
    })]
  });
};